export function extractScannedCode(scanData: any) {
  const rawValue = scanData[0].rawValue.trim()
  const serialMatch = rawValue.match(/\$Serial\+([^$\|\r\n]+)/i)
  return serialMatch?.[1]?.trim() ?? rawValue
}
